import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const firstRunExperienceDialog = () => import(/* webpackChunkName: "4-feat-fre" */ './FirstRunExperienceDialog');

export default lazyLoadOnRender({ loader: firstRunExperienceDialog });
